"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isZero = exports.getInt = exports.getFloat = void 0;

var getInt = function getInt(str) {
  if (!str) {
    return str;
  }

  try {
    return parseInt(str, 10);
  } catch (e) {
    return str;
  }
};

exports.getInt = getInt;

var getFloat = function getFloat(str) {
  if (!str) {
    return str;
  }

  try {
    return parseFloat(str);
  } catch (e) {
    return str;
  }
};

exports.getFloat = getFloat;

var isZero = function isZero(input) {
  if (typeof input === 'string') {
    var str = input.trim();
    return str === '0' || str === '0%';
  } else if (typeof input === 'number') {
    return input === 0;
  } else {
    return false;
  }
};

exports.isZero = isZero;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wdXJlLWZ1bmN0aW9ucy9wYXJzZS50cyJdLCJuYW1lcyI6WyJnZXRJbnQiLCJzdHIiLCJwYXJzZUludCIsImUiLCJnZXRGbG9hdCIsInBhcnNlRmxvYXQiLCJpc1plcm8iLCJpbnB1dCIsInRyaW0iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSxNQUFNLEdBQUcsU0FBVEEsTUFBUyxDQUFDQyxHQUFELEVBQVM7QUFDdEIsTUFBSSxDQUFDQSxHQUFMLEVBQVU7QUFBRSxXQUFPQSxHQUFQO0FBQWE7O0FBQ3pCLE1BQUk7QUFDRixXQUFPQyxRQUFRLENBQUNELEdBQUQsRUFBTSxFQUFOLENBQWY7QUFDRCxHQUZELENBRUUsT0FBTUUsQ0FBTixFQUFTO0FBQ1QsV0FBT0YsR0FBUDtBQUNEO0FBQ0YsQ0FQRDs7OztBQVNBLElBQU1HLFFBQVEsR0FBRyxTQUFYQSxRQUFXLENBQUNILEdBQUQsRUFBUztBQUN4QixNQUFJLENBQUNBLEdBQUwsRUFBVTtBQUFFLFdBQU9BLEdBQVA7QUFBYTs7QUFDekIsTUFBSTtBQUNGLFdBQU9JLFVBQVUsQ0FBQ0osR0FBRCxDQUFqQjtBQUNELEdBRkQsQ0FFRSxPQUFNRSxDQUFOLEVBQVM7QUFDVCxXQUFPRixHQUFQO0FBQ0Q7QUFDRixDQVBEOzs7O0FBU0EsSUFBTUssTUFBTSxHQUFHLFNBQVRBLE1BQVMsQ0FBQ0MsS0FBRCxFQUFXO0FBQ3hCLE1BQUksT0FBT0EsS0FBUCxLQUFpQixRQUFyQixFQUErQjtBQUM3QixRQUFNTixHQUFHLEdBQUdNLEtBQUssQ0FBQ0MsSUFBTixFQUFaO0FBQ0EsV0FBT1AsR0FBRyxLQUFLLEdBQVIsSUFBZUEsR0FBRyxLQUFLLElBQTlCO0FBQ0QsR0FIRCxNQUdPLElBQUksT0FBT00sS0FBUCxLQUFpQixRQUFyQixFQUErQjtBQUNwQyxXQUFPQSxLQUFLLEtBQUssQ0FBakI7QUFDRCxHQUZNLE1BRUE7QUFDTCxXQUFPLEtBQVA7QUFDRDtBQUNGLENBVEQiLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBnZXRJbnQgPSAoc3RyKSA9PiB7XG4gIGlmICghc3RyKSB7IHJldHVybiBzdHI7IH1cbiAgdHJ5IHtcbiAgICByZXR1cm4gcGFyc2VJbnQoc3RyLCAxMCk7XG4gIH0gY2F0Y2goZSkge1xuICAgIHJldHVybiBzdHI7XG4gIH1cbn1cblxuY29uc3QgZ2V0RmxvYXQgPSAoc3RyKSA9PiB7XG4gIGlmICghc3RyKSB7IHJldHVybiBzdHI7IH1cbiAgdHJ5IHtcbiAgICByZXR1cm4gcGFyc2VGbG9hdChzdHIpO1xuICB9IGNhdGNoKGUpIHtcbiAgICByZXR1cm4gc3RyO1xuICB9XG59XG5cbmNvbnN0IGlzWmVybyA9IChpbnB1dCkgPT4ge1xuICBpZiAodHlwZW9mIGlucHV0ID09PSAnc3RyaW5nJykge1xuICAgIGNvbnN0IHN0ciA9IGlucHV0LnRyaW0oKTtcbiAgICByZXR1cm4gc3RyID09PSAnMCcgfHwgc3RyID09PSAnMCUnO1xuICB9IGVsc2UgaWYgKHR5cGVvZiBpbnB1dCA9PT0gJ251bWJlcicpIHtcbiAgICByZXR1cm4gaW5wdXQgPT09IDA7XG4gIH0gZWxzZSB7XG4gICAgcmV0dXJuIGZhbHNlO1xuICB9XG59XG5cbmV4cG9ydCB7XG4gIGdldEludCxcbiAgZ2V0RmxvYXQsXG4gIGlzWmVyb1xufTsiXX0=